import { useCallback } from 'react';
import { TFormField } from 'js/components/common/Form/types';
import { TValidationMethod } from 'js/utils/Validation/types';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { getFieldValidations } from '../../../helpers';

export const useAddressLookupValidation = ({ field }: { field: TFormField }) => {
    const translate = useComponentTranslations();

    return useCallback<TValidationMethod<string>>(async () => {
        if (field.type !== FORM_FIELD_TYPE.ADDRESS_LOOKUP && field.type !== FORM_FIELD_TYPE.ADDRESS_LOOKUP_SWISS) {
            return;
        }

        const someInnerFieldsRequired = Object.values(field.innerFields)
            .filter(innerField => innerField.validation)
            .some(innerField => {
                const validations = getFieldValidations(innerField)?.[innerField.name] || [];

                return validations.some(conf => conf.type === 'required');
            });

        if (!someInnerFieldsRequired) {
            return;
        }

        return field.type === FORM_FIELD_TYPE.ADDRESS_LOOKUP
            ? translate('playtech.mobile.system.form.addressLookup.internal.required')
            : translate('playtech.mobile.system.form.addressLookupSwiss.internal.required');
    }, [field, translate]);
};
